import { FC } from "react";
import { TabPanels, TabPanelsAnimationType } from "@/components/TabPanels";

type TabPanelsBlockProps = {
  animation: TabPanelsAnimationType;
};

export const TabPanelsBlock: FC<TabPanelsBlockProps> = ({ animation }) => (
  <TabPanels animation={animation} />
);
